import React from "react";
import styles from "./IconsList.module.scss";
import IconsItem, { ItemProps } from "./IconsItem";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { Swiper, SwiperSlide } from "swiper/react";

interface Props {
    iconsItems: ItemProps[];
    smallGap?: boolean;
    isSlider: boolean;
    align?: "center" | "start" | "end";
}

const IconsList: React.FC<Props> = ({ iconsItems, smallGap, align, isSlider }) => {
    const matches2 = useMediaQuery("(min-width: 750px)");

    return (
        <ul className={[styles.advList, smallGap ? styles.smallGap : ""].join(" ")}>
            {!isSlider ? (
                <>
                    {iconsItems.map((i) => (
                        <IconsItem
                            iconName={i.iconName}
                            iconColor={i.iconColor}
                            text={i.text}
                            textColor={i.textColor}
                            key={i.text}
                            style={{ alignItems: align }}
                        />
                    ))}
                </>
            ) : matches2 ? (
                <>
                    {iconsItems.map((i) => (
                        <IconsItem
                            iconName={i.iconName}
                            iconColor={i.iconColor}
                            text={i.text}
                            textColor={i.textColor}
                            key={i.text}
                            style={{ alignItems: align }}
                        />
                    ))}
                </>
            ) : (
                <Swiper slidesPerView={1.4} spaceBetween={10} grabCursor={true}>
                    {iconsItems.map((i) => (
                        <SwiperSlide className={styles.slide}>
                            <IconsItem
                                iconName={i.iconName}
                                iconColor={i.iconColor}
                                text={i.text}
                                textColor={i.textColor}
                                key={i.text}
                                style={{ alignItems: align }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </ul>
    );
};

export default IconsList;
